import { hasLanguage } from 'ha/helpers/routes';

export default routes => (location, cbLang) => {
  if (hasLanguage(location)) {
    return cbLang(null, routes);
  }

  return cbLang(null, []);
};
